var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfCheckoutVisionSystems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 482 206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f1f0f0;\n      }\n\n      .cls-2 {\n        fill: #4c73c0;\n      }\n\n      .cls-3, .cls-4 {\n        fill: #ee7524;\n      }\n\n      .cls-3, .cls-5 {\n        opacity: .7;\n      }\n\n      .cls-6, .cls-7, .cls-8, .cls-9, .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-10, .cls-11 {\n        opacity: .3;\n      }\n\n      .cls-10, .cls-12 {\n        fill: #1a3526;\n      }\n\n      .cls-11, .cls-13 {\n        fill: #2ba17f;\n      }\n\n      .cls-14 {\n        fill: #e0e0e0;\n      }\n\n      .cls-7 {\n        opacity: .8;\n      }\n\n      .cls-15 {\n        opacity: .2;\n      }\n\n      .cls-16 {\n        fill: #ebebeb;\n      }\n\n      .cls-17 {\n        fill: #f5f5f5;\n      }\n\n      .cls-8 {\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: .2px;\n      }\n\n      .cls-9 {\n        opacity: .6;\n      }\n\n      .cls-18 {\n        fill: #e6e6e6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 43.7,
    y: 174.6,
    width: 236.1,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 249.2,
    y: 182.2,
    width: 7,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 196,
    y: 183.5,
    width: 4.1,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 231,
    y: 177.8,
    width: 16.1,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 75.1,
    y: 180.3,
    width: 20.4,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 99.7,
    y: 180.3,
    width: 7.4,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 119.8,
    y: 178.7,
    width: 44.2,
    height: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M155.7,153.5h-91.2c-1.5,0-2.7-1.2-2.7-2.7V22.7c0-1.5,1.2-2.7,2.7-2.7h91.2c1.5,0,2.7,1.2,2.7,2.7v128.2c0,1.5-1.2,2.7-2.7,2.7ZM64.5,20.1c-1.4,0-2.6,1.2-2.6,2.6v128.2c0,1.4,1.2,2.6,2.6,2.6h91.2c1.4,0,2.6-1.2,2.6-2.6V22.7c0-1.4-1.2-2.6-2.6-2.6h-91.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M257.8,153.5h-91.2c-1.5,0-2.7-1.2-2.7-2.7V22.7c0-1.5,1.2-2.7,2.7-2.7h91.2c1.5,0,2.7,1.2,2.7,2.7v128.2c0,1.5-1.2,2.7-2.7,2.7ZM166.6,20.1c-1.4,0-2.6,1.2-2.6,2.6v128.2c0,1.4,1.2,2.6,2.6,2.6h91.2c1.4,0,2.6-1.2,2.6-2.6V22.7c0-1.4-1.2-2.6-2.6-2.6h-91.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 78.9,
    y: 48.8,
    width: 44.7,
    height: 125.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 123.6,
    y: 48.8,
    width: 118.5,
    height: 125.8,
    transform: "translate(365.8 223.4) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 74.2,
    y: 64.5,
    width: 54.2,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 128.4,
    y: 64.5,
    width: 118.5,
    height: 3.1,
    transform: "translate(375.3 132.2) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 74.2,
    y: 83.4,
    width: 54.2,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 128.4,
    y: 83.4,
    width: 118.5,
    height: 3.1,
    transform: "translate(375.3 170) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 74.2,
    y: 102.3,
    width: 54.2,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 128.4,
    y: 102.3,
    width: 118.5,
    height: 3.1,
    transform: "translate(375.3 207.8) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 74.2,
    y: 121.2,
    width: 54.2,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 128.4,
    y: 121.2,
    width: 118.5,
    height: 3.1,
    transform: "translate(375.3 245.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 74.2,
    y: 140.1,
    width: 54.2,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 128.4,
    y: 140.1,
    width: 118.5,
    height: 3.1,
    transform: "translate(375.3 283.4) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 74.2,
    y: 159,
    width: 54.2,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 128.4,
    y: 159,
    width: 118.5,
    height: 3.1,
    transform: "translate(375.3 321.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 91.5,
    y: 10.5,
    width: 68,
    height: 33.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 122.6,
    y: 44.1,
    width: 5.8,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.5,
    y: 40.4,
    width: 68,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.5,
    y: 10.5,
    width: 68,
    height: 3.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 187.6,
    y: 24.5,
    width: 33.7,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 202.7,
    y: 45.8,
    width: 3.7,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 187.6,
    y: 43.5,
    width: 33.7,
    height: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 187.6,
    y: 24.5,
    width: 33.7,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 212.1,
    y: 52.6,
    width: 11.9,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 224.1,
    y: 52.6,
    width: 11.5,
    height: 11.9,
    transform: "translate(459.7 117.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 198,
    y: 52.6,
    width: 11.9,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 209.9,
    y: 52.6,
    width: 11.5,
    height: 11.9,
    transform: "translate(431.3 117.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 183.8,
    y: 52.6,
    width: 11.9,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 195.7,
    y: 52.6,
    width: 11.5,
    height: 11.9,
    transform: "translate(403 117.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 169.6,
    y: 52.6,
    width: 11.9,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 181.6,
    y: 52.6,
    width: 11.5,
    height: 11.9,
    transform: "translate(374.7 117.1) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 87.4,
    y: 70.9,
    width: 5,
    height: 12.5,
    transform: "translate(179.8 154.3) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 82.6,
    y: 70.9,
    width: 4.8,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 93.3,
    y: 70.9,
    width: 5,
    height: 12.5,
    transform: "translate(191.7 154.3) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 88.5,
    y: 70.9,
    width: 4.8,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 99.3,
    y: 70.9,
    width: 5,
    height: 12.5,
    transform: "translate(203.6 154.3) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 94.5,
    y: 70.9,
    width: 4.8,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 105.2,
    y: 70.9,
    width: 5,
    height: 12.5,
    transform: "translate(215.4 154.3) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 100.4,
    y: 70.9,
    width: 4.8,
    height: 12.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.5,
    y: 131.7,
    width: 6.7,
    height: 8.4,
    transform: "translate(189.7 271.8) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 85,
    y: 131.7,
    width: 6.5,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 99.5,
    y: 131.7,
    width: 6.7,
    height: 8.4,
    transform: "translate(205.7 271.8) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 93,
    y: 131.7,
    width: 6.5,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 107.5,
    y: 131.7,
    width: 6.7,
    height: 8.4,
    transform: "translate(221.7 271.8) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 101,
    y: 131.7,
    width: 6.5,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 115.5,
    y: 131.7,
    width: 6.7,
    height: 8.4,
    transform: "translate(237.7 271.8) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 109,
    y: 131.7,
    width: 6.5,
    height: 8.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 219.7,
    y: 90.4,
    width: 6.6,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 226.3,
    y: 90.4,
    width: 6.4,
    height: 11.9,
    transform: "translate(459 192.7) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 211.8,
    y: 90.4,
    width: 6.6,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 218.4,
    y: 90.4,
    width: 6.4,
    height: 11.9,
    transform: "translate(443.3 192.7) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 204,
    y: 90.4,
    width: 6.6,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 210.6,
    y: 90.4,
    width: 6.4,
    height: 11.9,
    transform: "translate(427.6 192.7) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 196.1,
    y: 90.4,
    width: 6.6,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 202.7,
    y: 90.4,
    width: 6.4,
    height: 11.9,
    transform: "translate(411.9 192.7) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 179,
    y: 90.4,
    width: 6.6,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 185.6,
    y: 90.4,
    width: 6.4,
    height: 11.9,
    transform: "translate(377.5 192.7) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 171.1,
    y: 90.4,
    width: 6.6,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 177.7,
    y: 90.4,
    width: 6.4,
    height: 11.9,
    transform: "translate(361.8 192.7) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 163.2,
    y: 90.4,
    width: 6.6,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 169.9,
    y: 90.4,
    width: 6.4,
    height: 11.9,
    transform: "translate(346.1 192.7) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 155.4,
    y: 90.4,
    width: 6.6,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 162,
    y: 90.4,
    width: 6.4,
    height: 11.9,
    transform: "translate(330.4 192.7) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 199.4,
    y: 131.7,
    width: 16.1,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 215.5,
    y: 131.7,
    width: 15.6,
    height: 8.4,
    transform: "translate(446.6 271.7) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 180.3,
    y: 131.7,
    width: 16.1,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 196.4,
    y: 131.7,
    width: 15.6,
    height: 8.4,
    transform: "translate(408.4 271.7) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 161.2,
    y: 131.7,
    width: 16.1,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 177.3,
    y: 131.7,
    width: 15.6,
    height: 8.4,
    transform: "translate(370.1 271.7) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 142,
    y: 131.7,
    width: 16.1,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 158.1,
    y: 131.7,
    width: 15.6,
    height: 8.4,
    transform: "translate(331.8 271.7) rotate(180)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 142.3,
    cy: 78.1,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 156.5,
    cy: 78.1,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 170.6,
    cy: 78.1,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 184.8,
    cy: 78.1,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 85.4,
    cy: 117.7,
    r: 3.5,
    transform: "translate(-24.8 22.8) rotate(-13.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 94.7,
    cy: 117.7,
    r: 3.5,
    transform: "translate(-24.5 24.9) rotate(-13.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 104.1,
    cy: 117.7,
    r: 3.5,
    transform: "translate(-44.5 168.8) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 113.4,
    cy: 117.7,
    r: 3.5,
    transform: "translate(-50 114.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 200.9,
    cy: 155.4,
    r: 3.6,
    transform: "translate(-19.5 281.5) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 210.6,
    cy: 155.4,
    r: 3.6,
    transform: "translate(-30.1 52.6) rotate(-13.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 220.3,
    cy: 155.4,
    r: 3.6,
    transform: "translate(-7.5 299.5) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 230.1,
    cy: 155.4,
    r: 3.6,
    transform: "translate(-1.5 308.4) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 205.9,
    cy: 150.3,
    r: 3.6,
    transform: "translate(-45.9 189.6) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 215.6,
    cy: 150.3,
    r: 3.6,
    transform: "translate(-5.7 292) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 225.3,
    cy: 150.3,
    r: 3.6,
    transform: "translate(-28.5 55.8) rotate(-13.3)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 153.8,
    cy: 155.4,
    r: 3.6,
    transform: "translate(-64.8 154.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 163.5,
    cy: 155.4,
    r: 3.6,
    transform: "translate(-42.6 247) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 173.2,
    cy: 155.4,
    r: 3.6,
    transform: "translate(-31.1 44) rotate(-13.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 182.9,
    cy: 155.4,
    r: 3.6,
    transform: "translate(-30.6 264.9) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 158.8,
    cy: 150.3,
    r: 3.6,
    transform: "translate(-40.8 239.5) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 168.5,
    cy: 150.3,
    r: 3.6,
    transform: "translate(-56.9 163.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 178.2,
    cy: 150.3,
    r: 3.6,
    transform: "translate(-28.8 257.4) rotate(-67.5)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "221.8 111.7 224.4 121.2 210.4 121.2 221.8 111.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "221.8 111.7 216.9 121.2 231.6 121.2 221.8 111.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "199.6 111.7 202.3 121.2 188.3 121.2 199.6 111.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.6 111.7 194.8 121.2 209.5 121.2 199.6 111.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "177.5 111.7 180.2 121.2 166.2 121.2 177.5 111.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "177.5 111.7 172.7 121.2 187.4 121.2 177.5 111.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "86.6 93.1 85.1 102.3 92.9 102.3 86.6 93.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "86.6 93.1 89.3 102.3 81 102.3 86.6 93.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "98.9 93.1 97.4 102.3 105.2 102.3 98.9 93.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "98.9 93.1 101.6 102.3 93.4 102.3 98.9 93.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "111.2 93.1 109.7 102.3 117.5 102.3 111.2 93.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "111.2 93.1 113.9 102.3 105.7 102.3 111.2 93.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "155.4 111.7 158.1 121.2 144.1 121.2 155.4 111.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "155.4 111.7 150.6 121.2 165.3 121.2 155.4 111.7"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E_",
    className: "cls-17",
    cx: 248.5,
    cy: 190.6,
    rx: 192.5,
    ry: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M352.5,124.6h39.1c1.7,0,3,1.3,3,3h0c0,1.7-1.3,3-3,3h-39.1v-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M352.5,124.6h39.1c1.7,0,3,1.3,3,3h0c0,1.7-1.3,3-3,3h-39.1v-6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 387.8,
    cy: 105.8,
    r: 4.5,
    transform: "translate(195.7 459) rotate(-76.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 387.8,
    cy: 105.8,
    r: 4.5,
    transform: "translate(195.7 459) rotate(-76.7)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "356.7 106.5 394.1 106.5 390.5 124.6 360.3 124.6 356.7 106.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M355.7,104.7h39.4c.4,0,.6.4.5.7l-.5,1.6c0,.2-.3.4-.5.4h-38.5c-.2,0-.5-.2-.5-.4l-.5-1.6c-.1-.4.2-.7.5-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M355.7,104.7h39.4c.4,0,.6.4.5.7l-.5,1.6c0,.2-.3.4-.5.4h-38.5c-.2,0-.5-.2-.5-.4l-.5-1.6c-.1-.4.2-.7.5-.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 360.4,
    y: 102.6,
    width: 17.9,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 360.4,
    y: 102.6,
    width: 17.9,
    height: 2.2
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M370.7,108.6c0,.3-.4.4-.6.4-1.4-.2-2.1-1.5-1.6-3.1l3.6-10.9c.6-1.7,2.4-3.1,4.2-3.1h6.4c1.7,0,2.7,1.4,2.1,3.1l-3.2,9.7h-1.1l3.2-9.7c.4-1.1-.2-2-1.4-2h-6.4c-1.1,0-2.4.9-2.7,2l-3.6,10.9c-.3.9,0,1.7.8,2,.3.1.5.4.4.7h0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 295.6,
    y: 103.3,
    width: 69,
    height: 82.9,
    rx: 8.6,
    ry: 8.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.4,134.3h-56.7c-1.7,0-3,1.3-3,3h0c0,1.7,1.3,3,3,3h56.7v-6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "312.4 142 295.6 149.6 295.6 140.3 312.4 140.3 312.4 142"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M312.4,134.3h-36.1c-1.7,0-3,1.3-3,3h0c0,1.7,1.3,3,3,3h36.1v-6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.4,
    y: 103.3,
    width: 50.2,
    height: 82.9,
    rx: 8.6,
    ry: 8.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 275.1,
    y: 140.3,
    width: 5.1,
    height: 45.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 275.1,
    y: 140.3,
    width: 5.1,
    height: 45.9
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "280.2 142.3 275.1 143.4 275.1 140.3 280.2 140.3 280.2 142.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 319.1,
    y: 113.1,
    width: 40.8,
    height: 15.5,
    rx: 2.5,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "290 95.2 262 95.2 259.1 134.3 292.8 134.3 290 95.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "265.7 95.2 262 95.2 259.1 134.3 266.7 134.3 265.7 95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M277.7,100c-2.6,0-5-1.8-5.3-4.3-.2-1.2.1-2.4.9-3.4.8-1.1,2.1-1.7,3.5-1.9,2.8-.3,5.4,1.7,5.9,4.3.2,1.2-.1,2.4-.9,3.4-.8,1.1-2.1,1.7-3.5,1.9-.2,0-.3,0-.5,0ZM277.2,91.3c-.1,0-.3,0-.4,0-1.2.1-2.3.7-2.9,1.5-.6.8-.9,1.8-.7,2.7.3,2.2,2.6,3.8,5,3.6,1.2-.1,2.3-.7,2.9-1.5.6-.8.9-1.8.7-2.7-.3-2-2.3-3.6-4.5-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M275.6,100c-.2,0-.3,0-.5,0-1.4-.1-2.7-.8-3.5-1.9-.8-1-1.1-2.2-.9-3.4.4-2.6,3-4.5,5.9-4.3,1.4.1,2.7.8,3.5,1.9.8,1,1.1,2.2.9,3.4-.4,2.4-2.7,4.3-5.3,4.3ZM276,91.3c-2.2,0-4.2,1.5-4.5,3.6-.2,1,0,2,.7,2.7.7.9,1.8,1.4,2.9,1.5,2.4.2,4.6-1.4,5-3.6.2-1,0-2-.7-2.7-.7-.9-1.8-1.4-2.9-1.5-.1,0-.3,0-.4,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 317.8,
    y: 41.9,
    width: 8.3,
    height: 61.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "326.1 74.8 317.8 74.8 317.8 90.8 326.1 89.8 326.1 74.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "326.1 42.3 317.8 42.3 317.8 47 326.1 46 326.1 42.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M300.3,86.2l-2.3-33.7c0-1.2.9-2.2,2.1-2.2h51.7c1.1,0,2,.8,2.1,1.9l2.3,33.7c0,1.2-.9,2.2-2.1,2.2h-51.7c-1.1,0-2-.8-2.1-1.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M351.1,51.9h-50.4c-.7,0-1.2.6-1.2,1.3l2.2,32.4c0,.6.6,1.1,1.2,1.1h50.4c.7,0,1.2-.6,1.2-1.3l-2.2-32.4c0-.6-.6-1.1-1.2-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M351.1,51.9h-50.4c-.7,0-1.2.6-1.2,1.3l2.2,32.4c0,.6.6,1.1,1.2,1.1h50.4c.7,0,1.2-.6,1.2-1.3l-2.2-32.4c0-.6-.6-1.1-1.2-1.1Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 307.4,
    y: 102.2,
    width: 44.2,
    height: 1.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "339.3 82.8 306 82.8 304.1 56 337.4 56 339.3 82.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "348.8 58.4 339.8 58.4 339.7 56 348.6 56 348.8 58.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "349.5 68.1 340.5 68.1 340 61.2 349 61.2 349.5 68.1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 313.4,
    y: 32.2,
    width: 16.7,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 313.4,
    y: 32.2,
    width: 7,
    height: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M366.2,85.9l.9-1.2c.3-.4.9-.7,1.4-.7h2.6c1,.2,2,.7,2.6,1.6l.4.5c-1.4,2.1-4.4,3.2-4.4,3.2l-.8.4c-.7.4-1.6.1-2-.6l-.9-1.6c-.3-.6-.2-1.3.2-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M375.3,62.4c.3.3.5.6.7.9.2.3.4.5.6.8.4.5.7,1.1,1.1,1.7.7,1.1,1.3,2.3,1.9,3.5.3.6.6,1.2.8,1.8.2.6.5,1.2.7,1.9.5,1.3.8,2.6,1.1,3.9v.2c0,.1,0,.3,0,.5,0,.9-.2,1.8-.5,2.5-.3.7-.6,1.3-1,1.8-.8,1-1.6,1.8-2.4,2.5-.9.7-1.7,1.2-2.6,1.7-.9.5-1.8.9-2.8,1.2-.9.3-1.9-.2-2.3-1.1-.2-.7,0-1.4.4-1.8h.1c.6-.7,1.3-1.3,1.8-1.9.6-.6,1.2-1.2,1.6-1.9.5-.6.9-1.2,1.1-1.8.2-.5.2-.9.1-.9v.7c-.3-1-.6-2-1.1-3-.5-1-.9-2-1.5-3-.5-1-1.1-1.9-1.7-2.9-.3-.5-.6-.9-.9-1.4l-.5-.7-.4-.6v-.2c-1.2-1.6-.9-3.8.7-4.9,1.5-1.1,3.6-.8,4.8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M368.8,58.4c-1.3,3-1.2,6.8,2.9,12.6,2.7.3,7.7-3.2,7.7-3.2,0,0-3.5-9.7-10.6-9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M366.5,47.9c-.8,2.9-1.8,8.3.1,10.2,0,0-2.8-.4-8.7,3.2-1.7-2.4-.4-3.2-.4-3.2,3.3-.8,3.4-3.2,3-5.5l5.9-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M354.6,60.3c.9-1.9,2.9-3.7,4.4-3.4s2.3.7,3.1,0c.8-.7,2.9-1.8,4-.6,1.5,1.6,3.7.5,2.9,2.3-.9,1.9-14.3,1.7-14.3,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M355.2,39.3s0-.1,0-.2c0-.1.2-.2.3-.2,1.3.3,1.7,1.3,1.7,1.4,0,.1,0,.2-.1.3-.1,0-.3,0-.3-.1,0,0-.3-.8-1.4-1.1,0,0-.1,0-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M369,42c-.9,4.7-1.2,6.7-3.9,9-4.1,3.4-9.6,1.6-10.2-3.2-.5-4.3,1.1-11.3,5.9-12.9,4.8-1.5,9,2.4,8.1,7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M358.5,43.5c-1.7-2.7-3.6-6-2.4-8.3,1.2-2.3,3.8-1.8,3.8-1.8,0,0,5.1-2.9,9.7.9,6.1,5-.4,10.4-2,15.2-1.8,5.2-11-1.1-9-5.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M384.6,34.8c-2.5-9.2-13.3-5-16.5.5l1.3.3c12.9-8.3,6.6,3.7,6.7,8.6.1,4.9,5,7.9,5,7.9,0,0,6-8.2,3.5-17.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M381.4,51.1c-1.4,0-3.3-.3-4.6-1.5-1.1-1.1-1.5-2.9-1-5.2.1-.7.4-1.6.6-2.5.7-2.8,1.7-6.3.2-7.6-1-.9-3.2-.6-6.4.9,0,0-.1,0-.2,0,0,0,0-.1,0-.2,3.4-1.5,5.6-1.8,6.7-.9,1.6,1.3.7,4.8-.1,7.8-.2.9-.5,1.7-.6,2.5-.4,2.2,0,3.9,1,5,2,2,6,1.3,6,1.3,0,0,.1,0,.1,0,0,0,0,.1,0,.1,0,0-.8.1-1.7.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M369.7,33.3c.1-.6-1.4-.3-1.5.2,0,.5-.3.2-.9,1-.6.8-.7,1.7,1.3,2.3,1.2.4,1.4-.6,2-1,.3-.3.7-.4,1-.6.3-.2.2-.7-.2-.7-.8,0-1.9-.6-1.8-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M359.3,45.2c-.5.9-1.3,1.5-2.1,1.7-1.1.2-1.5-1-1.1-2.3.4-1.1,1.4-2.6,2.5-2.3,1,.3,1.3,1.8.7,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M379.5,188.6c3.7-.5,3.7-1.2,5.7-1.8,1.7-.6,2.2-.5,3.5-1,1.1-.4.8-1.5,0-2.6-.4-.6-.4-1.1-.8-2.1l-5.6.8c-.5,1.6-.7,3.5-3.9,4.7-1.9.7-.4,2.3,1.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M345.5,188.6c3.6,0,4.4-.2,6.4-.3,1.8,0,2,.3,3.8.3s1.3-1.3.9-2.3c-.3-.8-.4-1.7-.6-2.7h-5c-.9,1.6-3.4,2.8-6.1,3-2,.1-.8,2.1.7,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M349.8,89.2s-.7,26.3.8,42.9c0,15.6.4,51.5.4,51.5.1.8,4.3.5,5,0,0,0,7.9-26.1,4.4-51.5,8.7-26.5,6.9-42.9,6.9-42.9h-17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M355,89.2s8.5,29.6,12,44.2c3.6,15.3,14.4,38.4,15.3,48.5.9.4,4,0,5.6-.8,0,0-1.5-32.3-10.3-47,2-36.2-7.8-44.9-7.8-44.9h-14.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M381.6,179.8c0,.5.1,1.4.1,2.1,0,.2.2.5.4.5,2.1,0,5-.9,5.9-1.2.2,0,.3-.2.3-.4v-2c0-.3-.2-.5-.5-.4l-5.9,1c-.2,0-.4.2-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M350.4,181.4c0,.5,0,1.5,0,2.2,0,.2.2.4.4.5,1.8.2,4.6,0,5.6,0,.2,0,.3-.2.4-.3l.4-1.9c0-.3-.2-.5-.4-.5l-5.7-.2c-.2,0-.4.2-.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M348.7,65.6c0,2-.1,4.5.1,9.2.2,4,.4,7.9,1,14.4h20c-.4-5.6.3-12.1,3.9-24.8.8-2.9-1-5.8-4-6.1-.8,0-1.6-.1-2.5-.2-3.4-.2-6.1-.3-9.1,0-1,0-2,.2-3,.4-3.5.5-6.3,3.6-6.4,7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M369.7,86.7c-4,1-10.1,1.3-20.1.2.2,5.3-2.1,41-2.1,41,0,0,20.3,4.5,31.8-1.6.7-27-9.6-39.7-9.6-39.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M362.1,108.2s5.5-5.1,8.2-8.6c-.2,3.7-3.5,7-8.2,8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M331.7,65.5l1.3.7c.5.3.8.7.9,1.3l.4,2.6c.2,1-.2,2.1-1,2.8l-.5.5c-2.3-1-4-3.7-4-3.7l-.6-.7c-.5-.6-.5-1.5.2-2.1l1.4-1.2c.5-.4,1.2-.5,1.8-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M355.6,66c-.1.4-.3.7-.4,1-.1.3-.3.6-.4.9-.3.6-.6,1.2-.9,1.8-.6,1.2-1.3,2.3-2,3.4-.4.6-.7,1.1-1.1,1.6-.4.5-.8,1.1-1.2,1.6-.8,1.1-1.8,2-2.8,3h-.1c-.1.2-.3.3-.4.4-.6.4-1.3.6-1.9.7-.6.1-1.2.1-1.7,0-1-.1-1.8-.4-2.5-.7-1.4-.6-2.4-1.4-3.4-2.2-1-.8-1.9-1.6-2.7-2.5-.8-.9-1.6-1.8-2.3-2.8-.6-.8-.4-1.9.4-2.5.6-.4,1.4-.4,2,0h0c.9.6,1.8,1.2,2.7,1.8.9.6,1.8,1.1,2.7,1.6.9.5,1.8.8,2.5,1,.4,0,.7.1.8,0,0,0,0,0,0,0,0,0-.2,0-.3,0l-.5.4c.7-.8,1.4-1.7,2-2.6.6-.9,1.2-1.8,1.8-2.8.6-1,1.1-2,1.6-3,.2-.5.5-1,.7-1.5l.3-.8.3-.7v-.2c.9-1.8,2.9-2.6,4.7-1.8,1.7.7,2.5,2.7,1.9,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M355.6,58.4c-3.3.4-6.5,2.5-9.3,8.9,1.2,2.5,6.8,4.9,6.8,4.9,0,0,6.5-8,2.5-13.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfCheckoutVisionSystems);
export default __webpack_public_path__ + "static/media/self-checkout-vision-systems.6bd51d56406a32632ca4e5294766b03d.svg";
export { ForwardRef as ReactComponent };